import ProductDatasetSource from '~/Api/Product/ProductDatasetSource';

export default class DatasetExtension {
	source: ProductDatasetSource;

	description: string | null;

	productRetrievedAt: Date | null;

	productUrl: string | null;

	validFrom: Date | null;

	rawData: { [key: string]: any };

	constructor(
		source: ProductDatasetSource,
		description: string | null,
		productRetrievedAt: Date | null,
		productUrl: string | null,
		validFrom: Date | null,
		rawData: { [key: string]: any }
	) {
		this.source = source;
		this.description = description;
		this.productRetrievedAt = productRetrievedAt;
		this.productUrl = productUrl;
		this.validFrom = validFrom;
		this.rawData = rawData;
	}
}
